import { render, staticRenderFns } from "./MovieContentArea.vue?vue&type=template&id=58985f64&scoped=true&"
import script from "./MovieContentArea.vue?vue&type=script&lang=ts&"
export * from "./MovieContentArea.vue?vue&type=script&lang=ts&"
import style0 from "./MovieContentArea.vue?vue&type=style&index=0&id=58985f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58985f64",
  null
  
)

export default component.exports